import api from '@/security/api'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

const findLast = () => {
    return api.get('/dashboard/campaign')
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar as campanhas')
        })
}

export default {
    findLast
}
